import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const pricingProfileCreateSchema = () =>
  yup.object().shape({
    name: yup
      .string()
      .nullable()
      .required(getEmptyErrorMessage(t('labelName'))),
    agreementId: yup.string().trim().nullable(),
    startDate: yup.date().label(t('labelStartDate')).nullable(),
    endDate: yup.date().label(t('labelEndDate')).nullable(),
    shareAccess: yup.boolean().nullable(),
  });
